<template>
    <span>
        <label>{{ libelleTraduit }}</label>
    </span>
</template>
<script setup lang="ts">
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    export interface IPropsLabelOnly {
        label: string
        dontTranslate?: boolean
        labelParameters?: object
    }

    const props = withDefaults(defineProps<IPropsLabelOnly>(), {
        label: '',
        dontTranslate: false,
    })

    const libelleTraduit = computed(() => {
        return props.dontTranslate || props.label == '' ? props.label : i18n.t(props.label, [props.labelParameters])
    })
</script>
